import { useEffect } from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import layoutStates from "../../../recoil/atoms/layout"
import { rtcAutoplayFailedState } from "../../../recoil/atoms/rtcAutoplayFailed"
import { BigUnMuteButton } from "./big-unmute-button"

type AutoPlayFailedOverlayProps = {
  width?: string,
  height?: string,  
  showLeaveOverlay: boolean
  isMobile: boolean
  isLandscape: boolean
}

const AutoPlayFailedOverlay = ({
  width,
  height,
  showLeaveOverlay,
  isMobile,
  isLandscape
}: AutoPlayFailedOverlayProps) => {
  const [isAutoplayFailed, setRtcAutoplayFailedState] = useRecoilState(
    rtcAutoplayFailedState
  )

  const showOnVideoOverlayContent = useRecoilValue(
    layoutStates.showOnVideoOverlayContent
  )

  useEffect(() => {
    const listener = () => {
      setRtcAutoplayFailedState(false)
    }
    if (isAutoplayFailed) {
      window.document.body.addEventListener("click", listener)
      window.document.body.addEventListener("touchstart", listener)
    }
    return () => {
      window.document.body.removeEventListener("click", listener)
      window.document.body.removeEventListener("touchstart", listener)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoplayFailed])

  const isDragToResizeVisible =
    isMobile && !showOnVideoOverlayContent && !isLandscape

  return (
    <BigUnMuteButton
      width={width}
      height={height}
      enabled={isAutoplayFailed && !isDragToResizeVisible}
      handlePlay={event => {
        event.stopPropagation()
        setRtcAutoplayFailedState(false)
      }}
      showLeaveOverlay={showLeaveOverlay}
    />
  )
}

export default AutoPlayFailedOverlay
